<template>
  <PdfTools />
</template>

<script>

export default {
    components: {
    },
    data() {
        return {

        }
    }
}
</script>

<style scoped lang="scss">

</style>
